/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserStatsDTO
 */
export interface UserStatsDTO {
    /**
     * 
     * @type {number}
     * @memberof UserStatsDTO
     */
    maximumDecks: number;
    /**
     * 
     * @type {number}
     * @memberof UserStatsDTO
     */
    maximumDeckSize: number;
    /**
     * 
     * @type {number}
     * @memberof UserStatsDTO
     */
    maximumExercises: number;
    /**
     * 
     * @type {number}
     * @memberof UserStatsDTO
     */
    maximumPlans: number;
    /**
     * 
     * @type {number}
     * @memberof UserStatsDTO
     */
    usedExercises: number;
    /**
     * 
     * @type {number}
     * @memberof UserStatsDTO
     */
    usedDecks: number;
    /**
     * 
     * @type {number}
     * @memberof UserStatsDTO
     */
    usedPlans: number;
}

/**
 * Check if a given object implements the UserStatsDTO interface.
 */
export function instanceOfUserStatsDTO(value: object): value is UserStatsDTO {
    if (!('maximumDecks' in value) || value['maximumDecks'] === undefined) return false;
    if (!('maximumDeckSize' in value) || value['maximumDeckSize'] === undefined) return false;
    if (!('maximumExercises' in value) || value['maximumExercises'] === undefined) return false;
    if (!('maximumPlans' in value) || value['maximumPlans'] === undefined) return false;
    if (!('usedExercises' in value) || value['usedExercises'] === undefined) return false;
    if (!('usedDecks' in value) || value['usedDecks'] === undefined) return false;
    if (!('usedPlans' in value) || value['usedPlans'] === undefined) return false;
    return true;
}

export function UserStatsDTOFromJSON(json: any): UserStatsDTO {
    return UserStatsDTOFromJSONTyped(json, false);
}

export function UserStatsDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserStatsDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'maximumDecks': json['maximumDecks'],
        'maximumDeckSize': json['maximumDeckSize'],
        'maximumExercises': json['maximumExercises'],
        'maximumPlans': json['maximumPlans'],
        'usedExercises': json['usedExercises'],
        'usedDecks': json['usedDecks'],
        'usedPlans': json['usedPlans'],
    };
}

export function UserStatsDTOToJSON(json: any): UserStatsDTO {
    return UserStatsDTOToJSONTyped(json, false);
}

export function UserStatsDTOToJSONTyped(value?: UserStatsDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'maximumDecks': value['maximumDecks'],
        'maximumDeckSize': value['maximumDeckSize'],
        'maximumExercises': value['maximumExercises'],
        'maximumPlans': value['maximumPlans'],
        'usedExercises': value['usedExercises'],
        'usedDecks': value['usedDecks'],
        'usedPlans': value['usedPlans'],
    };
}

